import { render, staticRenderFns } from "./PracticalWorkSessionCreation.vue?vue&type=template&id=5100b851&scoped=true"
import script from "./PracticalWorkSessionCreation.vue?vue&type=script&lang=js"
export * from "./PracticalWorkSessionCreation.vue?vue&type=script&lang=js"
import style0 from "./PracticalWorkSessionCreation.vue?vue&type=style&index=0&id=5100b851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100b851",
  null
  
)

export default component.exports